<template>
	<b-modal
		ref="disclaimerModal"
		title="Before You Download Your Agreement"
		@hidden="hideModal"
		size="lg"
		centered
	>
		<div class="disclaimer-content">
			<p class="mb-3">
				Please take a moment to review the following:
			</p>
			<ul class="disclaimer-list mb-3">
				<li class="mb-2"><b>Divii is software, not a law firm.</b> We don't provide legal advice or review your agreement for fairness or enforceability.</li>
				<li class="mb-2"><b>Your agreement is based entirely on the information you entered.</b> Divii does not verify financial, parenting, or other details.</li>
				<li class="mb-2"><b>There is no guarantee this agreement will be legally enforceable.</b> Enforceability depends on your circumstances, full disclosure, and whether independent legal advice is obtained.</li>
				<li class="mb-2"><b>Divii is a neutral platform.</b> Any decisions or outcomes are solely between you and the other party.</li>
				<li class="mb-2"><b>We strongly recommend independent legal advice</b> before signing a separation agreement.</li>
			</ul>
			<p>
				By downloading this agreement, you confirm that you understand and accept these points and agree to <b>Divii's Terms of Use.</b>
			</p>
		</div>

		<template #modal-footer>
			<b-button
				variant="pastel-blue"
				size="sm"
				@click="hideModal"
				data-testid="disclaimer-cancel"
			>
				Cancel
			</b-button>
			<b-button
				variant="primary"
				size="sm"
				@click="acceptAndDownload"
				data-testid="disclaimer-accept"
			>
				Download Agreement
			</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	props: {
		showDisclaimerModal: {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		hideModal() {
			this.$emit('close');
		},
		acceptAndDownload() {
			this.$emit('accept');
		}
	},
	watch: {
		showDisclaimerModal(value) {
			if (value) {
				this.$refs['disclaimerModal'].show();
			} else {
				this.$refs['disclaimerModal'].hide();
			}
		}
	}
};
</script>

<style scoped>
.disclaimer-list {
	list-style-type: disc;
	padding-left: 1.5rem;
}

.disclaimer-list li {
	line-height: 1.6;
}
</style>
